/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import {load, register} from '@shopify/theme-sections';
import * as product from '@shopify/theme-product';
import Variants from '@shopify/theme-variants';
import {ProductForm , getUrlWithVariant} from '@shopify/theme-product-form'
import {formatMoney} from '@shopify/theme-currency';
import Swiper, { Navigation, Pagination, Thumbs, A11y, Keyboard, FreeMode } from 'swiper';
import Drift from 'drift-zoom';

// Style includes
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';

const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productImageWrapper: '[data-product-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-page]',
    productPrice: '[data-product-price]',
    productThumbnailsSlider: 'carousel--product-thumbnails',
    productFeatureSlider: 'carousel--featured-product',
    productSlides: '.swiper-wrapper .swiper-slide',
    productThumbs: '[data-product-single-thumbnail]',
    productForm: '[data-product-form]',
    radioOptionSelector: '[data-radio-option-selector]',
    singleOptionSelector: '[data-single-option-selector]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaTypeVideo: '[data-product-media-type-video]',
    productMediaTypeModel: '[data-product-media-type-model]',
    variantOptionLabels: '.swatch__option label',
    formIncrement: ".form__increment",
    quantity: '#Quantity',
    productSwiperThumbs: null,
    productSwiperFeature: null,
    productSwiperFeatureSets: {}
};

const cssClasses = {
    activeThumbnail: 'active-thumbnail',
    hide: 'hide',
};

document.addEventListener("DOMContentLoaded", () => {
    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
    */
    register('product', {
        async onLoad() {
        this.$container = $(this.container);
        this.namespace = `.${this.id}`;
        var self = this;

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        const productFormElement = document.querySelector(selectors.productForm);

        this.product = await product.getProductJson(
            productFormElement.dataset.productHandle,
        );

        this.productForm = new ProductForm(productFormElement, this.product, {
            onOptionChange: this.onFormOptionChange.bind(this),
            onQuantityChange: this.onFormQuantityChange.bind(this)
        });

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!this.container.querySelector(selectors.productJson)?.innerHTML) {
            return;
        }

        this.productSingleObject = JSON.parse(
            $(selectors.productJson, this.$container).html(),
        );

        this.container.addEventListener('chooseNewSwatch', this.onForcedSwatchChange.bind(this));


        const options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            radioOptionSelector: this.radioOptionSelector,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject,
        };

        this.settings = {};
        this.variants = new Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on(
            `variantChange${this.namespace}`,
            this.updatePDPInformation.bind(this)
        );
        this.$container.on(
            `variantPriceChange${this.namespace}`,
            this.updateProductPrices.bind(this),
        );

        $('.form__increment').on('click', function() {

            self.$container.trigger({
                type: 'variantPriceChange',
                variant: self.variants.currentVariant
            });
        });

        $(selectors.quantity).on('change', function() {
            self.$container.trigger({
                type: 'variantPriceChange',
                variant: self.variants.currentVariant
            });
        });

        $(selectors.quantityWithID).on('change', function() {
            self.$container.trigger({
                type: 'variantPriceChange',
                variant: self.variants.currentVariant
            });
        });

        if (this.$featuredImage.length > 0) {
            this.$container.on(
                `variantImageChange${this.namespace}`,
                this.updateImages.bind(this),
            );
        }

        this.initProductCarousel();
        this.initProductVideo();
        this.updateImages({
            variant: this.variants.currentVariant
        });
        this.onForcedSwatchChange();
        this.initVariantTitles();
        this.updateVariantSaleTag(this.variants.currentVariant);
        this.initVariantHoverWatch();
        this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
        this.initStickyCart();
        // this.initDescriptionReadMore();
        // this.initProductZoom();


            const breakpoint = window.matchMedia( '(min-width:1024px)' );

            const checkBreakpoint = function(options) {
                if ( breakpoint.matches === true ) {
                    if ( selectors.productSwiperThumbs !== null ) {
                        selectors.productSwiperThumbs.disable( true, true );
                    }
                    if ( selectors.productSwiperFeature !== null ) {
                        selectors.productSwiperFeature.disable( true, true );
                    }
                    return;
                } else if ( breakpoint.matches === false ) {
                    return options.initProductCarousel();
                }
            };
            breakpoint.addEventListener('change', () => checkBreakpoint(this));
            checkBreakpoint(this);
            this.initProductVideo();

            this.initVariantTitles();
            this.initVariantHoverWatch();
            this.updateVariantAvailability(this.container, this.currentVariant);
            this.initStickyCart();
            this.initProductZoom();
            if (this.featuredImage && this.swiperSlides.length > 1) {
                this.updateImages({variant: this.currentVariant, target: this.container});
            }
        },

        onFormOptionChange(event) {
            const currentVariant = {variant: event.dataset.variant, target: this.container};
            if (currentVariant.variant) {
                this.currentVariant = currentVariant.variant;
                var current_var_id  = $(this).attr('variantid');
                if(current_var_id != '' && current_var_id != undefined){
                  var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + current_var_id;
                  window.history.replaceState({path: newurl}, '', newurl);
                }
            }

            this.updatePDPInformation(currentVariant);
            this.updateProductPrices(currentVariant);
            this.updateURLwithVariant(currentVariant);

            if (this.featuredImage && this.swiperSlides.length > 1) {
                this.updateImages(currentVariant);
            }

        },

        onForcedSwatchChange() {
            const currentVariant = {variant: this.productForm.variant(), target: this.container};


            if (currentVariant.variant) {
                this.currentVariant = currentVariant.variant;
            }

            this.updatePDPInformation(currentVariant);
            this.updateProductPrices(currentVariant);
            this.updateURLwithVariant(currentVariant);

            if (this.featuredImage && this.swiperSlides.length > 1) {
                this.updateImages(currentVariant);
            }
        },

        onFormQuantityChange(event) {
            const currentVariant = {variant: event.dataset.variant, target: this.container};
            this.updateProductPrices(currentVariant);
        },

        initVariantTitles() {
            this.changeVariantTitles(this.currentVariant);
        },

        updateURLwithVariant(event) {
            const variant = event.variant;

            if (!variant) return;

            const url = getUrlWithVariant(window.location.href, variant.id);
            window.history.replaceState({ path: url }, '', url);
        },

        updatePDPInformation(event) {
            this.updateAddToCartState(event);
            this.changeVariantTitles(event);
            this.changeProductCarousel(event);
        },

        updateAddToCartState(event) {
            const variant = event.variant;
            this.updateVariantAvailability(event.target, variant);

            if (variant) {
                this.container.querySelector(selectors.priceWrapper).classList.remove(cssClasses.hide);
            } else {
                this.container.querySelector(selectors.addToCart).disabled = true;
                this.container.querySelector(selectors.addToCartText).innerHTML = theme.strings.unavailable;
                this.container.querySelector(selectors.priceWrapper).classList.add(cssClasses.hide);
                return;
            }

            if (variant.available) {
                this.container.querySelector(selectors.addToCart).disabled = false;
                this.container.querySelector(selectors.addToCartText).innerHTML = theme.strings.addToCart;
            } else {
                this.container.querySelector(selectors.addToCart).disabled = true;
                this.container.querySelector(selectors.addToCartText).innerHTML = theme.strings.soldOut;
            }
        },

        changeVariantTitles() {


            $('.swatch__option input[data-single-option-selector]:checked').each(function() {
                var container = $(this).parents('.form__element');
                var subtitle = container.find('.swatch__title .swatch__subtitle');
                subtitle.text($(this).val());

                var optionIndex = $(this).attr("data-index");
                $('.sticky-container__product-option[data-index="'+optionIndex+'"]').find('.sticky__option-value').text($(this).val());
              })
        },

        tempChangeVariantTitle(event) {
            var target = event.currentTarget;
            var newLabel = target.textContent;
            var container = target.closest('.form__element');
            var subtitle = container.querySelector('.swatch__title .swatch__subtitle');
            subtitle.textContent = newLabel;
        },

        initVariantHoverWatch() {
            const changeVariantTitles = this.changeVariantTitles;
            const tempChangeVariantTitle = this.tempChangeVariantTitle;
            document.querySelectorAll('.swatch__option input[data-single-option-selector] + label.form__option-label').forEach((swatch__option) => {
                swatch__option.addEventListener('mouseenter', tempChangeVariantTitle);
                swatch__option.addEventListener('mouseleave', changeVariantTitles);
            });
        },

        updateImages(event) {
            const variant = event.variant;
            if (typeof variant.featured_media != 'undefined') {
                const imageId = this.id + "-" + variant.featured_media.id;
                this.swapImage(imageId);
            }
        },

        updateProductPrices(evt) {
            const variant = evt.variant;
            if (!variant) {
                return false;
            }
            const comparePrice = this.container.querySelector(selectors.comparePrice);
            const comparePriceText = this.container.querySelector(selectors.comparePriceText);
            const quantity = parseInt(this.container.querySelector(selectors.quantity).value);

            this.container.querySelector(selectors.productPrice).innerHTML = formatMoney(variant.price, theme.moneyFormat);

            const priceWithQuantity = variant.price * quantity;
            document.querySelector('#addToCartPricing').innerHTML = formatMoney(priceWithQuantity, theme.moneyFormat);

            if (variant.compare_at_price > variant.price) {
                comparePrice.innerHTML = formatMoney(variant.compare_at_price, theme.moneyFormat);
                comparePrice.classList.remove(cssClasses.hide);
                comparePriceText.classList.remove(cssClasses.hide);
                this.container.querySelector(selectors.productPrice).classList.add('price__original--sale');
            } else if(comparePrice) {
                comparePrice.innerHTML = '';
                comparePrice.classList.add(cssClasses.hide);
                comparePriceText.classList.add(cssClasses.hide);
                this.container.querySelector(selectors.productPrice).classList.remove('price__original--sale');
            }
        },

        disableVariants(target, valuesToEnable) {
            // Loop through all the Option Selectors and check which one is a swatch selector
            // The target is usually the main product container
            const optionSelector1 = target.querySelectorAll('[data-index="option1"]');
            const optionSelector2 = target.querySelectorAll('[data-index="option2"]');
            const optionSelector3 = target.querySelectorAll('[data-index="option3"]');
            let is_swatch_selector1 = false;
            let is_swatch_selector2 = false;
            let is_swatch_selector3 = false;

            if (optionSelector1.length > 0 && optionSelector1[0].getAttribute('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2[0].getAttribute('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3[0].getAttribute('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            const option1 = target.querySelectorAll('input[data-index="option1"]');
            const option2 = target.querySelectorAll('input[data-index="option2"]');
            const option3 = target.querySelectorAll('input[data-index="option3"]');

            // If there are 3 option selectors
            if (optionSelector3.length > 0) {

                // If the third option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 2.
                if (is_swatch_selector3 == true) {

                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                    })

                    option2.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                    })

                    option3.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option3.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    })

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 3.
                } else if (is_swatch_selector2 == true) {

                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                    });

                    option2.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option2.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    });

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2 and 3.
                } else if (is_swatch_selector1 == true) {

                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    })
                }

            // If there are 2 option selectors
            } else if (optionSelector2.length > 0) {

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1.
                if (is_swatch_selector2 == true) {

                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                    });

                    option2.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option2.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    });

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2.
                } else if (is_swatch_selector1 == true) {

                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    })
                }
            } else {
                if (is_swatch_selector1 == true) {
                    option1.forEach((option) => {
                        const input = option;
                        input.nextElementSibling.classList.remove('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            input.nextElementSibling.classList.add('swatch--disabled');
                        }
                    });
                }
            }
        },

        updateVariantAvailability(target, variant) {
            var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }


            if (!variant) {
                return;
            }
            var variants = this.variants.product.variants;
            var currentVariant = {
                id: variant.id,
                title: variant.title,
                option1: variant.option1,
                option2: variant.option2,
                option3: variant.option3
            };

            // Combine all available variants
            var availableVariants = variants.filter(function(el) {
              if (!el.available) {
                return false;
              }

                // Option 1
                if ((currentVariant.option2 === el.option2 || !el.option2) && (currentVariant.option3 === el.option3 || !el.option3)) {
                  return true;
                }

                // Option 2
                if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option3 === el.option3 || !el.option3)) {
                  return true;
                }

                // Option 3
                if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option2 === el.option2 || !el.option2)) {
                  return true;
                }

              });

            var variantObject = {
                variant: currentVariant
            };
            availableVariants = Object.assign({}, variantObject, availableVariants);
            for (var property in availableVariants) {
                if (availableVariants.hasOwnProperty(property)) {
                  var item = availableVariants[property];
                  var option1 = item.option1;
                  var option2 = item.option2;
                  var option3 = item.option3;

                  if (option1) {
                    if (availableValues.option1.indexOf(option1) === -1) {
                        availableValues.option1.push(option1);
                    }
                  }
                  if (option2) {
                    if (availableValues.option2.indexOf(option2) === -1) {
                      availableValues.option2.push(option2);
                    }
                  }
                  if (option3) {
                    if (availableValues.option3.indexOf(option3) === -1) {
                      availableValues.option3.push(option3);
                    }
                  }
                }
            }


            this.disableVariants(target, availableValues);
        },

        updateVariantSaleTag(variant) {
            const container = this.$container[0];
            const product_id = this.variants.product.id;
            const product_tag = $(container).find('.product__tag--variant');

            if (product_tag.length) {

                if (variant) {
                    var sale_calc = (100 - ((variant.price / variant.compare_at_price) * 100)).toFixed(0);
                    var sale_message = sale_calc + '% off';
                    var sale_tag_exist = false;
                    var new_flavor_tag_exist = false;
                    var var_sale_tag_exist = false;
                    var saleFlavor;
                    var hasFlavor;
                    var newwFlavor;

                    // Determines if a product variant has a custom sale based on flavor & size combo
                    if (product_tag.find('[data-variant-sale]').html()) {
                        var varsale_json = JSON.parse(product_tag.find('[data-variant-sale]').html());

                        $.each(varsale_json, function(i, v) {

                            let varName = v.variant_name.replaceAll('-', ' ');

                            if (v.has_flavor) {
                                hasFlavor = v.has_flavor[0].replaceAll('-', ' ');
                            }

                            if (v.has_flavor !== null && varName.includes(hasFlavor)) {
                                saleFlavor = hasFlavor;
                            }


                            if (v.variant_iid === variant.id) {

                                if (hasFlavor !== null && v.has_size !== null && varName.includes(v.has_flavor) && v.variant_name.includes(v.has_size) ) {
                                  var_sale_tag_exist = true;
                                }
                              }
                        });
                    }

                    if (!var_sale_tag_exist) {
                        product_tag.find('[data-product-badge-varsale]').addClass('hide');
                        product_tag.find('[name="properties[_exclude]"]').val('false');

                        if ($('body').hasClass('template-product')) {
                            $('.product__options').find('[name="properties[_exclude]"]').val('false');
                        }
                    }

                    if (var_sale_tag_exist) {
                        product_tag.find('[data-product-badge-varsale]').removeClass('hide');
                        product_tag.find('[name="properties[_exclude]"]').val('yes-sale');

                        if ($('body').hasClass('template-product')) {
                            $('.product__options').find('[name="properties[_exclude]"]').val('yes-sale');
                        }
                    }
                }
            }
        },

        initStickyCart() {
            const options = {
                rootMargin: '100px 0px 0px 0px',
                threshold: [0,0.01,1]
            }
            const target = document.querySelector('#productStickyContainer');
            const observer = new IntersectionObserver(this.showHideStickyCart, options);

            observer.observe(target);
        },

        showHideStickyCart(entries, observer) {
            let entry = entries[0];
            if (entry.intersectionRatio >= 1) {
                entry.target.classList.remove('product__sticky--show');
            } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                entry.target.classList.add('product__sticky--show');
                entry.target.classList.remove('product__sticky--hide');
            } else {
                entry.target.classList.add('product__sticky--hide');
            }
        },

        initProductVideo: function() {
            const sectionId = this.id;
            const videoContainers = document.querySelectorAll(selectors.productMediaTypeVideo, this.container);

            videoContainers.forEach((videoContainer) => {
                ProductVideo.init(videoContainer, sectionId);
            });
        },

        initProductZoom: function() {
            if (matchMedia('(pointer:fine)').matches && window.innerWidth> 1023) {
                const driftImgs = document.querySelectorAll('.js--image-zoom');
                const pane = document.querySelector('.product__feature-image');

                driftImgs.forEach((image) => {

                    // Documentation link for reference: https://github.com/imgix/drift#basic-usage
                    new Drift(image, {
                        paneContainer: pane,
                        inlinePane: false,
                        handleTouch: false,
                        injectBaseStyles: true,
                        hoverDelay: 200,
                    });
                })
            }
        },

        initProductCarousel: function() {
          let self = this;
          // -------------------------------------
          // Carousel Products
          // -------------------------------------
          const productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'.current-variant', {
              // Optional parameters
              modules: [Pagination],
              spaceBetween: 0,
              observer: true,
              observeParents: true,
              autoHeight: true,
              watchOverflow: false,
              hashNavigation: {
                watchState: true,
             },
              pagination: {
                  el: ".current-variant .product-swiper-pagination",
                  type: 'bullets',
                  clickable: true,
                  bulletElement: 'button'
              },
              a11y: true,
              breakpoints: {
                // when window width is >= 680px
                1024: {
                  watchOverflow: false,
                  slidesPerView: 5
                }
              },
              on: {
                  init: function() {
                      toggleInnerFocus(this);
                  }
              }
          });

           productFeatureSwiper.on('slideChange ', function () {
            // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
              var previousSlideIndex = productFeatureSwiper.previousIndex,
                  currentSlideIndex = productFeatureSwiper.activeIndex;

              // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
              var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                  previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');

              previousMedia.trigger("mediaHidden");
              currentMedia.trigger("mediaVisible");
                toggleInnerFocus(this);

                productFeatureSwiper.pagination.render();
                productFeatureSwiper.pagination.update();
          });


          //selectors.productSwiperThumbs = productThumbnailSwiper;
          selectors.productSwiperFeature = productFeatureSwiper;
          let featuredMediaId = $(productFeatureSwiper.wrapperEl).parent().attr('data-product-featured-image');
          if (!selectors.productSwiperFeatureSets[featuredMediaId]) {
              selectors.productSwiperFeatureSets[featuredMediaId] = productFeatureSwiper;
          }
      },

      changeProductCarousel(event) {
        let featuredMediaId;

        if (event.variant && event.variant.featured_media) {
            featuredMediaId = event.variant.featured_media.id;
        } else {
            featuredMediaId = "placeholder";
        }

        let carousels = event.target.querySelectorAll(`[data-product-featured-image]`);

        if(carousels.length != 0) {
             carousels.forEach(function(carousel) {
                carousel.classList.remove('current-variant');
            })
            let newCarousel = event.target.querySelector(`[data-product-featured-image="${featuredMediaId}"]`);
            newCarousel.classList.add('current-variant');

            // Disable old carousel
            selectors.productSwiperFeature.disable();

            // Enable or initialize new carousel
            if (selectors.productSwiperFeatureSets[featuredMediaId]) {
                selectors.productSwiperFeatureSets[featuredMediaId].enable();
            } else {
                this.initProductCarousel();
            }
        }
    },
        slideToSlide(slider, slideIndex, transition) {
            if (transition) {
                slider.slideTo(slideIndex);
            } else {
                slider.slideTo(slideIndex, 0);
            }
        },

        // triggering change image when using with Slider
        swapImage(imageId) {

        let newImageId = imageId;

        // If "imageId" is not defined in the function parameter, find it by the current product image
        if (typeof newImageId === 'undefined') {
            newImageId = $(
                `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
            ).data('image-id');
        }

        // const $thumbnail = $(
        //     `${selectors.productThumbs}[data-thumbnail-id='${newImageId}']`,
        // );

        //var slideIndex = parseInt($thumbnail.parents('.swiper-slide').attr('data-index'));

        // Swipe JS
        //this.slideToSlide(selectors.productSwiperThumbs, slideIndex, false);
        //this.slideToSlide(selectors.productSwiperFeature, slideIndex, false);

    },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
            this.productForm.destroy();
        },

    });



    /**
     * Load Video content on Product Swiper
     */
    const ProductVideo = (() => {
        const videos = {};

        const hosts = {
            html5: 'html5',
            youtube: 'youtube'
        };

        const attributes = {
            enableVideoLooping: 'enable-video-looping',
            videoId: 'video-id'
        };

        // Initialize Video Container
        const init = (videoContainer, sectionId) => {
            if (!videoContainer) {
                return;
            }

            const videoElement = videoContainer.querySelectorAll('iframe, video')[0];
            const mediaId = videoContainer.dataset.mediaId;

            if (!videoElement) {
                return;
            }

            videos[mediaId] = {
                mediaId: mediaId,
                sectionId: sectionId,
                host: hostFromVideoElement(videoElement),
                container: videoContainer,
                element: videoElement,
            };

            const video = videos[mediaId];
            switch (video.host) {
                case hosts.html5:
                    setupPlyrVideos();
                    break;
                case hosts.youtube:
                    setupYouTubeVideos();
                    break;
            }
        }

        // Set Up HTML 5 Players
        const setupPlyrVideos = () => {
            loadVideos(hosts.html5);
        }

        // Set Youtube embedded Videos
        const setupYouTubeVideos = () => {
            window.YT.ready(function() {
                loadVideos(hosts.youtube);
            });
        }

        // Create Video Player
        const createPlayer = (video) => {
            if (video?.player) {
                return;
            }

            const productMediaWrapper = video.container.closest(
                selectors.productMediaWrapper
            );
            const enableLooping = productMediaWrapper.dataset[attributes.enableVideoLooping];

            switch (video.host) {
                case hosts.html5:
                    video.player = new Shopify.Plyr(video.element, {
                        loop: { active: enableLooping }
                    });
                    toggleInnerFocus(selectors.productSwiperFeature);
                    break;
                case hosts.youtube:
                    const videoId = productMediaWrapper.dataset[attributes.videoId];
                    video.player = new YT.Player(video.element, {
                        videoId: videoId,
                        events: {
                            onStateChange: (event) => {
                                if (event.data === 0 && enableLooping) event.target.seekTo(0);
                            }
                        }
                    });
                    break;
            }

            productMediaWrapper.addEventListener('mediaHidden', () => {
                if (!video.player) return;

                if (video.host === hosts.html5) {
                    video.player.pause();
                }

                if (video.host === hosts.youtube && video.player.pauseVideo) {
                    video.player.pauseVideo();
                }
            });

            productMediaWrapper.addEventListener('mediaVisible', () => {
                if (!video.player) return;

                if (video.host === hosts.html5) {
                    video.player.play();
                }

                if (video.host === hosts.youtube && video.player.playVideo) {
                    video.player.playVideo();
                }
            });
        }

        // Get host source from Video
        const hostFromVideoElement = (video) => {
            if (video.tagName === 'VIDEO') {
                return hosts.html5;
            }

            if (video.tagName === 'IFRAME') {
                if (
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    video.src
                    )
                ) {
                    return hosts.youtube;
                }
            }
            return null;
        }

        // Load Video Players
        const loadVideos = (host) => {
            for (const videoId in videos) {
                const video = videos.hasOwnProperty(videoId) ? videos[videoId] : null;

                if (video?.host === host) createPlayer(video);
            }
        }

        // Remove Video Players
        const removeSectionVideos = (sectionId) => {
            for (const videoId in videos) {
                const video = videos.hasOwnProperty(videoId) ? videos[videoId] : null;

                if (video?.sectionId === sectionId) {
                    if (video.player) video.player.destroy();
                    delete videos[key];
                }
            }
        }

      return {
        init: init,
        hosts: hosts,
        loadVideos: loadVideos,
        removeSectionVideos: removeSectionVideos
      };
    })();

    load('product');
})

/**
 * Slider Accessibility Helper
 */
const toggleInnerFocus = (slider) => {
    const focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    focusableElements.forEach((fosusableElement) => {
        slider.slides.forEach((slide, index) => {
            if (index === slider.activeIndex) {
                if (fosusableElement === '.plyr') {
                    slide.querySelector(fosusableElement)?.setAttribute('tabindex', '0');
                } else {
                    slide.querySelectorAll(fosusableElement).forEach((elem) => {
                        elem?.removeAttribute('tabindex');
                    });
                }
            } else {
                slide.querySelectorAll(fosusableElement).forEach((elem) => {
                    elem?.setAttribute('tabindex', '-1');
                });
            }
        });
    });
}
